import { computed } from 'mobx';

export default class UserModel {
  id;
  store;

  constructor(store, user) {
    this.store = store;
    this.id = +user.id;
    this.username = user.username;
    this.name = user.name;
    this.designation = user.designation;
    this.role_id = +user.role_id;
    this.role_name = user.role_name;
    this.email = user.email;
    this.mobile = user.mobile;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      username: this.username,
      name: this.name,
      designation: this.designation,
      role_id: +this.role_id,
      role_name: this.role_name,
      email: this.email,
      mobile: this.mobile
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.username = json.username;
    this.name = json.name;
    this.designation = json.designation;
    this.role_id = +json.role_id;
    this.role_name = json.role_name;
    this.email = json.email;
    this.mobile = json.mobile;
  }
}



// WEBPACK FOOTER //
// ./src/models/UserModel.js